module.exports = __webpack_public_path__ + "images/category_lp/jewel/store_images/4_742a99b13cf74f9868edeaf862a1f9eb.png";